import React from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';
import StyledSnackbarProviderContainer from './PinnacleSnackbarProvider.styled';
import PinnacleNotificationComplete from './partials/PinnacleficationComplete';
import { PinnacleNotificationCompleteProps, PinnacleSnackbarProps } from './PinnacleSnackbarProvider.types';

export const NOTIFICATION_TIMEOUT = 5000;

let enqueueSnackbarOutsideReact: ReturnType<typeof useSnackbar>['enqueueSnackbar'] | null = null;

export const pushNotification = (notification: PinnacleNotificationCompleteProps) => {
  if (enqueueSnackbarOutsideReact) {
    const { title, details = '', type, timeout = NOTIFICATION_TIMEOUT } = notification;
    enqueueSnackbarOutsideReact(title ? title : details, {
      variant: 'PinnacleNotificationComplete',
      title,
      details,
      type,
      autoHideDuration: timeout,
      persist: false,
    });
  } else {
    console.error('Snackbar not initialized yet!');
  }
};

const SnackbarUtilsInitializer: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  enqueueSnackbarOutsideReact = enqueueSnackbar;
  return null;
};

const PinnacleSnackbarProvider: React.FC<PinnacleSnackbarProps> = (props) => {
  const { notification } = props;
  let timeout = NOTIFICATION_TIMEOUT;

  if (notification) {
    const { title = '', details, timeout: notifTimeout } = notification;
    timeout = notifTimeout ?? NOTIFICATION_TIMEOUT;

    pushNotification({
      title,
      details: details ?? '',
      type: notification.type,
      timeout,
    });
  }

  return (
    <StyledSnackbarProviderContainer>
      <SnackbarProvider
        autoHideDuration={timeout}
        Components={{
          PinnacleNotificationComplete: PinnacleNotificationComplete as React.ComponentType<PinnacleNotificationCompleteProps>,
        }}
        maxSnack={1}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <SnackbarUtilsInitializer />
        {props.children}
      </SnackbarProvider>
    </StyledSnackbarProviderContainer>
  );
};

export default PinnacleSnackbarProvider;
